import { ReactNode } from 'react'
import { styled } from 'styled-components'

import { PrimaryButton } from '../actions/special/DynamicWidthButtons'
import { TightSectionContent } from '../containers/TightSectionContent'
import { Divider } from '../decorative/Divider'
import { SPACE_XXSMALL } from '../global/spacing'

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: ${SPACE_XXSMALL};
`

export enum Mode {
  SingleButton = 'single-button',
  Slot = 'slot',
}

export interface SingleButtonModeProps {
  mode: Mode.SingleButton
  buttonLabel: string
  isLoading?: boolean
  onButtonClick: () => void
}

export interface SlotModeProps {
  mode: Mode.Slot
  children: ReactNode
}

export type CtaSectionProps = SingleButtonModeProps | SlotModeProps

export const CtaSection = (props: CtaSectionProps) => {
  const { mode } = props
  let content: ReactNode

  if (mode === Mode.SingleButton) {
    content = (
      <PrimaryButton
        label={props.buttonLabel}
        onClick={props.onButtonClick}
        disabled={props.isLoading}
        loading={props.isLoading}
      />
    )
  } else if (mode === Mode.Slot) {
    content = props.children
  } else {
    throw new Error('Unhandled mode')
  }

  return (
    <TightSectionContent>
      <Divider />
      <ButtonContainer>{content}</ButtonContainer>
    </TightSectionContent>
  )
}
